import axios from 'axios';

export default class SettingsService
{
    public static async fetch(key: string)
    {
        return (await axios.get<Record<string, any>>(`admin/settings/${key}`)).data;
    }

    public static async fetchMonitoring()
    {
        return (await axios.get<MonitoringFormModel>(`admin/settings/monitoring`)).data;
    }

    public static async save(key: string, model: Record<string, any>)
    {
        return (await axios.post<Statement>(`admin/settings/${key}`, model)).data;
    }

    public static async saveMonitoring(model: MonitoringFormModel)
    {
        return (await axios.post<Statement>(`admin/settings/monitoring`, model)).data;
    }

    public static async restartApplication()
    {
        return (await axios.post<Statement>(`admin/settings/restart-application`)).data;
    }
}

export interface MonitoringFormModel
{
    openTelemetry: OpenTelemetryOptions;
    sentry: SentryOptions;
}

export interface OpenTelemetryOptions
{
    enabled: boolean;
    target: number;
    uri: string;
    authRequired: boolean;
    headers: string;
    serviceName: string;
    serviceNamespace: string;
    netRuntimeEnabled: boolean;
    httpMonitoringEnabled: boolean;
    httpMonitoringEndpoints: string;
    databaseMonitoringEnabled: boolean;
    tracesSampleRate: number;
    ignoreFastSQLs: boolean;
    fastSQLThreshold: number;
}

export interface SentryOptions
{
    enabled: boolean;
    dsn: string;
    profilingEnabled: boolean;
    sendDefaultPii: boolean;
    attachStackTrace: boolean;
    tracingEnabled: boolean;
    tracesSampleRate: number;
    profilesSampleRate: number;
}
